import { getPartnerFromParticipant } from 'modules/boards/utils';
import { Board, BoardParticipant, Partner } from 'types';

type GetParticipantSharesProps = {
  board: Board;
  participant: BoardParticipant;
  partners: Partner[];
};

export const getParticipantShares = ({
  board,
  participant,
  partners,
}: GetParticipantSharesProps): number => {
  const partner = getPartnerFromParticipant(participant, partners);

  const shares = board?.societySharesCount
    ? participant?.sharesCount || 0
    : partner?.sharesCount?.actual || 0;

  return shares;
};
